import { render } from "./OpenHourIndex.vue?vue&type=template&id=a1fd9930"
import script from "./OpenHourIndex.vue?vue&type=script&lang=js"
export * from "./OpenHourIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__